// extracted by mini-css-extract-plugin
export default {"removeStyle":"NavListItems_removeStyle__VBXog"};